import React from "react";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 60,
  height: 30,
  padding: 0,
  display: "flex",
  "& .MuiSwitch-switchBase": {
    padding: 3,
    "&.Mui-checked": {
      transform: "translateX(30px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "rgb(57, 54, 239)",
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 24,
    height: 24,
    backgroundColor: "#fff",
    boxShadow: "0 1px 3px rgb(57, 54, 239)",
  },
  "& .MuiSwitch-track": {
    borderRadius: 30 / 2,
    backgroundColor: "#fff",
    opacity: 1,
    transition: "background-color 0.3s, box-shadow 0.3s",
    border: "2px solid rgb(85 83 228)",
  },
  "& .Mui-disabled": {
    "&.Mui-checked": {
      "& + .MuiSwitch-track": {
        backgroundColor: "rgb(146 144 241)",
        opacity: 1,
      },
    },
  },
}));

export default function SwitchToggle({
  checked = true,
  onChange,
  disabled = true,
  props,
}) {
  return (
    <CustomSwitch
      checked={checked}
      onChange={onChange}
      {...props}
      disabled={disabled}
    />
  );
}
